export default class AdminAccountDto {
    constructor(adminAccountData) {
        this.email = adminAccountData?.email;
        this.firstname = adminAccountData?.firstname;
        this.lastname = adminAccountData?.lastname;
        this.phoneNumber = adminAccountData?.phone;
        this.languageCode = adminAccountData?.language;
    }
}